<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center">
      <h3>注册信息审核</h3>
    </div>

    <el-form :inline="!UI.isMobile" :label-position="UI.isMobile ? 'top' : 'right'" size="mini" :model="filterForm">
      <el-form-item label="名字">
        <el-input clearable v-model="filterForm.name" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="是否审核通过">
        <el-select v-model="filterForm.is_approved">
          <el-option :value="item.value" :label="item.label" v-for="(item, key) in $approveConsts"
            :key="key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="
          filterForm.page = 1;
        flushData();
        ">
          查询
        </el-button>

        <el-button @click="resetFilter()">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="user_id" label="ID"></el-table-column>

      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="organization" label="单位"></el-table-column>

      <el-table-column label="性别" prop="sex" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ scope.row.sex == 0 ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column prop="role" label="身份">
        <template slot-scope="scope">
          {{ getRole(scope.row) }}
        </template>
      </el-table-column>

      <el-table-column label="籍贯" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ scope.row.native_place.join() }}
        </template>
      </el-table-column>

      <el-table-column label="民族" prop="nation" v-if="!UI.isMobile"></el-table-column>

      <el-table-column label="免冠头像" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="
            fileUrl = scope.row.avatar;
          isShow = true;
          ">
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="身份证" prop="identifier_code" v-if="!UI.isMobile"></el-table-column>

      <el-table-column label="身份证扫描件" v-if="!UI.isMobile && filterForm.role == $roleConsts.ORG_PLAYER.value">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="
            fileUrl = scope.row.identifier_image;
          isShow = true;
          ">
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="户籍证明" v-if="!UI.isMobile && filterForm.role == $roleConsts.ORG_PLAYER.value">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="
            fileUrl = scope.row.household_image;
          isShow = true;
          ">
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="代表资格协议" v-if="!UI.isMobile && filterForm.role == $roleConsts.ORG_PLAYER.value">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="
            fileUrl = scope.row.contract;
          isShow = true;
          ">
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="协议时间" v-if="!UI.isMobile && filterForm.role == $roleConsts.ORG_PLAYER.value">
        <template slot-scope="scope">
          {{ scope.row.contract_start_time }} ->
          {{ scope.row.contract_end_time }}
        </template>
      </el-table-column>

      <el-table-column label="裁判等级" v-if="!UI.isMobile && filterForm.role == $roleConsts.TECH_OFFICER.value">
        <template slot-scope="scope">
          {{ scope.row.referee_level }}
        </template>
      </el-table-column>

      <el-table-column label="赛事履历" show-overflow-tooltip
        v-if="!UI.isMobile && filterForm.role == $roleConsts.TECH_OFFICER.value">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" v-if="scope.row.referee_resume && scope.row.referee_resume.length > 20"
            @click="
              fileUrl = `text:${scope.row.referee_resume}`;
            isShow = true;
            ">
            查看
          </el-button>
          <div v-else>
            {{ scope.row.referee_resume }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="签字">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="
            fileUrl = scope.row.sign;
          isShow = true;
          " :disabled="!scope.row.sign">
            查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="状态" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-tag size="small" :type="approveBtn[scope.row.is_approved]">
            {{ $getApproveLabel(scope.row.is_approved) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="查看信息" v-else>
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="
            info = scope.row;
          isInfoShow = true;
          ">
            点击查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button @click="approve(scope.row.id, $approveConsts.APPROVED.value)" type="success" size="small"
            :disabled="scope.row.is_approved == $approveConsts.APPROVED.value">
            通过
          </el-button>
          <el-button @click="approve(scope.row.id, $approveConsts.REJECTED.value)" type="danger" size="small"
            :disabled="scope.row.is_approved == $approveConsts.REJECTED.value">
            驳回
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination :hide-on-single-page="total <= filterForm.page_size" @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page" :page-size="filterForm.page_size" layout="total, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>

    <el-dialog show-close :fullscreen="UI.isMobile" title="查看" :visible.sync="isInfoShow" width="98%"
      v-if="UI.isMobile">
      <div class="padding-xs">
        <el-descriptions :column="1" border>
          <el-descriptions-item v-for="(value, key) in info" :key="key" :label="key">
            <div v-if="!(value + '').startsWith('http')">{{ value }}</div>
            <div v-else>
              <el-button type="primary" size="small" @click="
                fileUrl = value;
              isShow = true;
              ">
                点击查看
              </el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="isShow" width="800px" show-close :fullscreen="UI.isMobile">
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <div v-else-if="fileUrl.startsWith('text:')" style="white-space: pre-line">
        {{ fileUrl.substring(5).trim() }}
      </div>
      <img v-else :src="fileUrl" style="max-width: 500px;"></img>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfoList, userInfoApprove } from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import pdf from '@/components/pdfShow.vue';

export default {
  components: {
    pdf,
  },

  data() {
    return {
      info: {},
      isInfoShow: false,
      isShow: false,
      fileUrl: '',
      filterForm: {
        page: 1,
        page_size: 10,
        role: undefined,
      },
      total: 0,
      tableData: [],
      approveBtn: ['warning', 'success', 'danger', 'info'],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.filterForm.role = this.$route.query.role;
    this.flushData();
  },

  watch: {
    $route: function (to, from) {
      this.filterForm.role = this.$route.query.role;
      this.flushData();
    },
  },

  methods: {
    flushData: function () {
      let that = this;
      getUserInfoList(this.filterForm, function (res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    resetFilter: function () {
      this.filterForm = {
        page: 1,
        page_size: 10,
        role: this.$route.query.role,
      };
      this.flushData();
    },

    approve: function (orgId, state) {
      let that = this;
      userInfoApprove(orgId, state, function (res) {
        showSuccessMsg(res);
        that.flushData();
      });
    },

    handleCurrentChange: function () {
      this.flushData();
    },

    getRole: function (row) {
      let res = [];
      for (let key in this.$roleConsts) {
        if (this.$roleConsts[key].value == row.role) {
          res.push(this.$roleConsts[key].label);
        } else if (
          row.extra_roles && row.extra_roles.includes(this.$roleConsts[key].value)
        ) {
          res.push(this.$roleConsts[key].label);
        }
      }
      return res.join('/');
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/approve/user.vue